import { LoginPolicyType } from 'api/security/idp';
import { useAccountMetaQuery } from 'queries';
export const getChangedPayload = (oldCofig, formData)=>{
    const payload = {
        idpId: oldCofig.idpId,
        enabled: oldCofig.enabled,
        saml: {}
    };
    Object.entries(formData).forEach(([key, value])=>{
        var _oldCofig_idpMeta;
        if (formData[key] !== (oldCofig === null || oldCofig === void 0 ? void 0 : (_oldCofig_idpMeta = oldCofig.idpMeta) === null || _oldCofig_idpMeta === void 0 ? void 0 : _oldCofig_idpMeta[key])) {
            payload.saml[key] = value;
        }
    });
    return payload;
};
export var LoginPolicyDisplayType = /*#__PURE__*/ function(LoginPolicyDisplayType) {
    LoginPolicyDisplayType["Optional"] = "Optional";
    LoginPolicyDisplayType["Only"] = "Only";
    return LoginPolicyDisplayType;
}({});
export const getLoginPolicyDisplayValue = (accountMeta, loginPolicy)=>{
    if (!accountMeta || !loginPolicy) {
        return undefined;
    }
    const { companyId } = accountMeta.company;
    const idp = loginPolicy.find((policy)=>policy.companyId === companyId && policy.authType === LoginPolicyType.Idp);
    return (idp === null || idp === void 0 ? void 0 : idp.mandatory) ? "Only" : "Optional";
};
const getSaml = (samlConfigs)=>samlConfigs === null || samlConfigs === void 0 ? void 0 : samlConfigs.find((config)=>config.idpId);
export const getLoginPolicyPayload = (displayValue, accountMeta, oldLoginPolicy, samlConfigs)=>{
    if (!accountMeta || !oldLoginPolicy) {
        return undefined;
    }
    const { companyId } = accountMeta.company;
    const newPolicy = oldLoginPolicy.map((policy)=>{
        if (policy.companyId !== companyId) {
            return policy;
        }
        if (displayValue === "Only") {
            if (policy.authType === LoginPolicyType.Idp) {
                return {
                    ...policy,
                    mandatory: true
                };
            }
        }
        return {
            ...policy,
            mandatory: false
        };
    });
    const predicateByOurIdp = (policy)=>policy.companyId === companyId && policy.authType === LoginPolicyType.Idp;
    if (newPolicy.find(predicateByOurIdp)) {
        return newPolicy;
    }
    const samlConfig = getSaml(samlConfigs);
    if (!samlConfig) {
        return newPolicy;
    }
    return [
        ...newPolicy,
        {
            authType: LoginPolicyType.Idp,
            companyId,
            enabled: true,
            default: false,
            idpConfigId: samlConfig.accountIdpConfigId,
            mandatory: displayValue === "Only"
        }
    ];
};
export const getEnabledIdp = (oktaMetaData)=>{
    var _oktaMetaData_idps;
    return oktaMetaData === null || oktaMetaData === void 0 ? void 0 : (_oktaMetaData_idps = oktaMetaData.idps) === null || _oktaMetaData_idps === void 0 ? void 0 : _oktaMetaData_idps.find((idp)=>idp.enabled);
};
export const useIsSamlMandatory = ()=>{
    var _ref;
    var _data_company_authentications_find, _data_company_authentications, _data_company;
    const { data } = useAccountMetaQuery();
    if (!data) {
        return false;
    }
    const isSamlEnabled = !!((_ref = data === null || data === void 0 ? void 0 : data.okta.idps) !== null && _ref !== void 0 ? _ref : []).filter((idp)=>idp.enabled).length;
    const isSamlMandated = ((_data_company = data.company) === null || _data_company === void 0 ? void 0 : (_data_company_authentications = _data_company.authentications) === null || _data_company_authentications === void 0 ? void 0 : (_data_company_authentications_find = _data_company_authentications.find((auth)=>auth.authType === LoginPolicyType.Idp)) === null || _data_company_authentications_find === void 0 ? void 0 : _data_company_authentications_find.mandatory) || false;
    // if ssoEnabled is true and saml is mandated, return true
    return isSamlEnabled && isSamlMandated;
};
